export const MAX_BORROWER_UPLOAD_FILE_SIZE = 8388608; // 8mb (note: bucketAV has 2gb limit)

export const MAX_ISO_8601_DATE = new Date('12/31/9999');
